export const forgotPassNumberSelector = (state) => state.forgotPassword.phoneNumber;
export const forgotPassCodeSelector = (state) => state.forgotPassword.code;
